/* tslint:disable */
/* eslint-disable */
export enum MessageClass {
    Location = 'LOCATION',
    Bim = 'BIM',
    Function = 'FUNCTION',
    Export = 'EXPORT'
}
